export const styles = {
  container: {
    marginBottom: '8px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    overflow: 'visible', // Changed from 'hidden' to avoid nested scroll container issues with react-beautiful-dnd
    '&:before': {
      display: 'none',
    },
    '&.MuiAccordion-root': {
      border: 'none',
      boxShadow: 'none',
    }
  },
  summary: {
    backgroundColor: '#ffffff',
    padding: '16px 20px',
    borderRadius: '8px 8px 0 0',
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
  },
  summaryContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexGrow: 1,
    cursor: 'pointer'
  },
  titleText: {
    flexGrow: 1,
    fontWeight: 'bold',
    color: '#333333',
    fontSize: '14px',
  },
  taskItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    marginLeft: '16px',
  },
  taskContent: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
  },
  taskName: {
    color: '#333333',
    fontSize: '14px',
    lineHeight: '1.2',
  },
  taskLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexGrow: 1,
  },
  chipContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  details: {
    padding: '8px 20px 16px 20px',
    backgroundColor: '#fafafa',
    borderRadius: '0 0 8px 8px',
    // Removed maxHeight and overflowY to avoid nested scroll container issues with react-beautiful-dnd
    // The parent container should handle scrolling instead
  },
  milestoneHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    padding: '8px 0',
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '8px',
  },
  taskCount: {
    fontSize: '12px',
    color: '#666666',
    backgroundColor: '#f0f0f0',
    padding: '2px 8px',
    borderRadius: '12px',
  },
  taskChip: {
    marginLeft: '8px',
  },
  unsavedChip: {
    marginLeft: '8px',
  },
  draftChip: {
    backgroundColor: '#ed6c02',
    color: '#ffffff',
  },
  releasedChip: {
    backgroundColor: '#2e7d32',
    color: '#ffffff',
  },
  taskCheckbox: {
    padding: '4px',
    marginRight: '8px',
  },
  milestoneCheckbox: {
    padding: '4px',
  },
}; 